const VERSION: string = '0.1.7-prod.13'
export default VERSION;
